import styled from "styled-components/macro";
import { media } from "../../../../utils";

export const FiqueAtentoTitle = styled.span(({ theme }) => ({
  color: theme.color.neutral["05"],
}));

export const FiqueAtentoContent = styled.div`
  background-color: ${({ theme }) => theme.color.brandPrimary.medium};
  padding: 32px 20px;
  color: ${({ theme }) => theme.color.line.light};
`;

export const ContentPassoAPasso = styled.div({
  [media.lg()]: {
    ".DoubleContent__ResizableColumn": {
      alignItems: "flex-start",
    },
  },
});
